import { releaseItem } from './releaseItem';

export function topNews() {
  //.js-topNewsクラスを取得
  const topNews = document.querySelector('.js-topNews');

  //jsonデータをカテゴリーでフィルターにかける
  const dataCateFilter = (array,val) => {
    return array.filter(item => item.category === val);
  }

  //jsonデータの出力件数に絞る
  const dataLimit = (array, num) => {
    return array.slice(0, num);
  }

  //jsonデータをhtmlで吐き出す
  const newsList = (array) => {
    //出力する件数を指定
    let limit = 5;
    const list_els = topNews.querySelectorAll('.js-topNews_list');
    list_els.forEach(el => {
      let category = el.dataset.category;

      let posts = [];
      if(category === 'ALL') {
        posts = array;
      } else {
        posts = dataCateFilter(array,category);
      }

      let posts_list = dataLimit(posts, limit);

      posts_list.forEach(post => {
        let item = releaseItem(post);
        el.appendChild(item);
      });
    });
  }

  //jsonデータを取得してくる
  const getReleaseList = () => {
    const url = `https://secure02.red.shared-server.net/www.o-tec.co.jp/cron_marge/data/top.json`; //遅延情報のJSON
    fetch(url, {
      method : "GET",
      headers: {
        'Content-Type': 'application/json' // JSON形式のデータのヘッダー
      }
    })
    .then((response) => {
      return response.json()　//ここでBodyからJSONを返す
    })
    .then((result) => {
      newsList(result);
    })
    .catch((e) => {
        console.log(e)  //エラーをキャッチし表示     
    })
  }

  if(topNews) { //.js-topNewsクラスがページに存在する場合
    getReleaseList();
  }
}